import { render, staticRenderFns } from "./FaultOrder.vue?vue&type=template&id=223a0b9c&scoped=true&"
import script from "./FaultOrder.vue?vue&type=script&lang=js&"
export * from "./FaultOrder.vue?vue&type=script&lang=js&"
import style0 from "./FaultOrder.vue?vue&type=style&index=0&id=223a0b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a0b9c",
  null
  
)

export default component.exports